import script from "./PageHeader.vue?vue&type=script&setup=true&lang=ts"
export * from "./PageHeader.vue?vue&type=script&setup=true&lang=ts"

import "./PageHeader.vue?vue&type=style&index=0&id=2f0ae4b1&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2f0ae4b1"]])

export default __exports__